<div class="page_title">
  <div class="container-fluid">
    <div class="row">
      <div class="col-auto mt-2" *ngIf="this.claimId">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
          [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
        </k-button>
      </div>
      <div class="col">
        <h3>New Audiometry Test</h3>
        <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
      </div>
    </div>
  </div>
</div>

<form class="audiometryTestForm" name="audiometryTestForm" [formGroup]="audiometryTestForm">
  <div class="container-fluid">
    <div class="pages_space">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3">
          <div class="card_claimInfo_wrap">
            <div class="row">
              <div class="col-12" style="margin-top: 5px;">
                <k-card [card]="claimInfo"></k-card>
              </div>

              <div class="col-12" style="margin-top: 5px;">
                <k-label [tooltipText]="'Type of Audiometry'" [helpText]="'Type of Audiometry'" for="dropdown" [required]="true">Type of Audiometry </k-label>
                <k-dropdown formControlName="audiometryType" name="dropdown" [options]="audiometryTypeList"></k-dropdown>
                <div *ngIf="isSubmitted && f.audiometryType.errors">
                  <div *ngIf="isSubmitted && f.audiometryType.errors" class="errors_block">Audiometry type is required
                  </div>
                </div>
              </div>

              <!-- <div class="col-12" style="margin-top: 5px;">
                <k-label [tooltipText]="'Years exposed to Noise(Including other employments)'" [required]="true" [helpText]="'Years exposed to Noise(Including other employments)'"
                  >Years exposed to Noise(Including other employments)</k-label>
                  <k-dynamic-input formControlName="yearsExposedToNoise" [inputType]="dynamicNumberInput"></k-dynamic-input>
                  <div *ngIf="isSubmitted && f.yearsExposedToNoise.errors">
                    <div *ngIf="isSubmitted && f.yearsExposedToNoise.errors.required" class="errors_block">Value is required</div>
                    <div *ngIf="f.yearsExposedToNoise.errors.negative" class="errors_block">Enter only integers greater than 0</div>
                  </div>
              </div> -->
              <div class="col-12" style="margin-top: 5px;">
                <k-label [tooltipText]="'Years exposed to Noise(Including other employments)'" [required]="true" [helpText]="'Years exposed to Noise(Including other employments)'">
                  Years exposed to Noise (Including other employments)
                </k-label>
                <k-dynamic-input formControlName="yearsExposedToNoise" [inputType]="dynamicNumberInput"></k-dynamic-input>
                
                <div *ngIf="isSubmitted && f.yearsExposedToNoise.errors">
                  <div *ngIf="f.yearsExposedToNoise.errors.required" class="errors_block">Value is required</div>
                  <div *ngIf="f.yearsExposedToNoise.errors.range" class="errors_block">Enter an integer between 1 and 49</div>
                </div>
              </div>
              

              <div class="col-12" style="margin-top: 5px;" *ngIf="!hideEmployer">
                <k-label [tooltipText]="'Employer'" [helpText]="'Employer'" for="dropdown" [required]="false">Employer</k-label>
                <k-dropdown formControlName="employerName" name="dropdown" [options]="employerList" (change)="getNotionalExposure(audiometryTestForm.controls.employerName.value)"></k-dropdown>
                <div *ngIf="isSubmitted && f.employerName.errors">
                  <div *ngIf="isSubmitted && f.employerName.errors" class="errors_block">Employer is required</div>
                </div>
              </div>

              <div class="col-12" style="margin-top: 5px;">
                <k-label [tooltipText]="'Notional Exposure'" [helpText]="'Notional Exposure'" [required]="true">Notional Exposure</k-label>
                <k-dynamic-input formControlName="notionalExposure" [inputType]="dynamicDropDownInput" [options]="notionalExposureOptions"></k-dynamic-input>
                <div *ngIf="isSubmitted && f.notionalExposure.errors">
                  <div *ngIf="isSubmitted && f.notionalExposure.errors" class="errors_block">Notional Exposure is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <p class="subTitle">Right Ear</p>
          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'250 Hz'" [helpText]="'250 Hz'" [required]="false" class="hzLabel">250
                Hz</k-label>
              <k-dynamic-input formControlName="r250hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r250hz.errors">
                <div *ngIf="isSubmitted && f.r250hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r250hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r250hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r250hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'500 Hz'" [helpText]="'500 Hz'" [required]="false" class="hzLabel">500
                Hz</k-label>
              <k-dynamic-input formControlName="r500hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r500hz.errors">
                <div *ngIf="isSubmitted && f.r500hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r500hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r500hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r500hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'1000 Hz'" [helpText]="'1000 Hz'" [required]="true" class="hzLabel">1000
                Hz</k-label>
              <k-dynamic-input formControlName="r1000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r1000hz.errors">
                <div *ngIf="isSubmitted && f.r1000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r1000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r1000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r1000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'2000 Hz'" [helpText]="'2000 Hz'" [required]="false" class="hzLabel">2000
                Hz</k-label>
              <k-dynamic-input formControlName="r2000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r2000hz.errors">
                <div *ngIf="isSubmitted && f.r2000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r2000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r2000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r2000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'3000 Hz'" [helpText]="'3000 Hz'" [required]="false" class="hzLabel">3000
                Hz</k-label>
              <k-dynamic-input formControlName="r3000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r3000hz.errors">
                <div *ngIf="isSubmitted && f.r3000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r3000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r3000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r3000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'4000 Hz'" [helpText]="'4000 Hz'" [required]="false" class="hzLabel">4000
                Hz</k-label>
              <k-dynamic-input formControlName="r4000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r4000hz.errors">
                <div *ngIf="isSubmitted && f.r4000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r4000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r4000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r4000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'6000 Hz'" [helpText]="'6000 Hz'" [required]="false" class="hzLabel">6000
                Hz</k-label>
              <k-dynamic-input formControlName="r6000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r6000hz.errors">
                <div *ngIf="isSubmitted && f.r6000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r6000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r6000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r6000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'8000 Hz'" [helpText]="'8000 Hz'" [required]="true" class="hzLabel">8000
                Hz</k-label>
              <k-dynamic-input formControlName="r8000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.r8000hz.errors">
                <div *ngIf="isSubmitted && f.r8000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.r8000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.r8000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.r8000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <p class="subTitle">Left Ear</p>
          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'250 Hz'" [helpText]="'250 Hz'" [required]="false" class="hzLabel">250
                Hz</k-label>
              <k-dynamic-input formControlName="l250hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l250hz.errors">
                <div *ngIf="isSubmitted && f.l250hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l250hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l250hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l250hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'500 Hz'" [helpText]="'500 Hz'" [required]="false" class="hzLabel">500
                Hz</k-label>
              <k-dynamic-input formControlName="l500hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l500hz.errors">
                <div *ngIf="isSubmitted && f.l500hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l500hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l500hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l500hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'1000 Hz'" [helpText]="'1000 Hz'" [required]="true" class="hzLabel">1000
                Hz</k-label>
              <k-dynamic-input formControlName="l1000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l1000hz.errors">
                <div *ngIf="isSubmitted && f.l1000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l1000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l1000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l1000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'2000 Hz'" [helpText]="'2000 Hz'" [required]="false" class="hzLabel">2000
                Hz</k-label>
              <k-dynamic-input formControlName="l2000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l2000hz.errors">
                <div *ngIf="isSubmitted && f.l2000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l2000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l2000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l2000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'3000 Hz'" [helpText]="'3000 Hz'" [required]="false" class="hzLabel">3000
                Hz</k-label>
              <k-dynamic-input formControlName="l3000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l3000hz.errors">
                <div *ngIf="isSubmitted && f.l3000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l3000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l3000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l3000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'4000 Hz'" [helpText]="'4000 Hz'" [required]="false" class="hzLabel">4000
                Hz</k-label>
              <k-dynamic-input formControlName="l4000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l4000hz.errors">
                <div *ngIf="isSubmitted && f.l4000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l4000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l4000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l4000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'6000 Hz'" [helpText]="'6000 Hz'" [required]="false" class="hzLabel">6000
                Hz</k-label>
              <k-dynamic-input formControlName="l6000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l6000hz.errors">
                <div *ngIf="isSubmitted && f.l6000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l6000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l6000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l6000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'8000 Hz'" [helpText]="'8000 Hz'" [required]="true" class="hzLabel">8000
                Hz</k-label>
              <k-dynamic-input formControlName="l8000hz" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.l8000hz.errors">
                <div *ngIf="isSubmitted && f.l8000hz.errors.required" class="errors_block">Value is required</div>
                <div *ngIf="isSubmitted && f.l8000hz.errors.min" class="errors_block">Minimum value allowed is -50</div>
                <div *ngIf="isSubmitted && f.l8000hz.errors.max" class="errors_block">Maximum value allowed is 130</div>
                <!-- <div *ngIf="f.l8000hz.errors.negative" class="errors_block">Enter only integers greater than 0</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="row">
            <div class="col-12 mb-3">
              <k-label [tooltipText]="'Audiogram Date'" [helpText]="'Audiogram Date'" for="dropdown" [required]="true">Audiogram Date </k-label>
              <k-dynamic-input formControlName="audiogramDate" [min]="DOB" [inputType]="dynamicDateInput"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.audiogramDate.errors">
                <div *ngIf="isSubmitted && f.audiogramDate.errors?.required" class="errors_block">Audiogram date is required</div>
                <div *ngIf="isSubmitted && f.audiogramDate.errors?.invalidDate" class="errors_block">Audiometry test must be after the claimant's date of birth</div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <k-label [tooltipText]="'Loss'" [helpText]="'Loss'" [required]="isMandatory('loss')">Overall Binaural Hearing Loss (dB) </k-label>
              <k-dynamic-input formControlName="loss" [inputType]="dynamicNumberInput" [allowBlankValue]="true"></k-dynamic-input>
              <div *ngIf="isSubmitted && f.loss.errors">
                <div *ngIf="isSubmitted && f.loss.errors.required" class="errors_block">Loss is required</div>
                <div *ngIf="isSubmitted && f.loss.errors.notInteger" class="errors_block">Enter an integer from -10 to 70
                </div>
                <div *ngIf="isSubmitted && (f.loss.errors?.min || f.loss.errors?.max)" class="errors_block">
                  Overall Binaural Hearing Loss (dB) Value must be between -10 and 70.
                </div>
              </div>
            </div>

            <div class="col-12 mb-3 audiologist">
              <k-label [tooltipText]="'Audiologist'" [helpText]="'Audiologist'" [required]="isMandatory('audiologist')">Audiologist</k-label>
              <k-combobox formControlName="audiologist" [allowNewValues]="true" [maxVisibleItems]="10" [limitOptionsLength]="true" [source]="sourceURL" [optionsLookupPath]="'data'"></k-combobox>
              <!-- <k-dynamic-input formControlName="audiologist" [inputType]="dynamicStringInput"></k-dynamic-input> -->
              <div *ngIf="f.audiologist.errors">
                <div *ngIf="f.audiologist.dirty && f.audiologist.errors.required" class="errors_block">Audiologist is required</div>
                <div *ngIf="isSubmitted && !f.audiologist.dirty && f.audiologist.errors.required" class="errors_block">Audiologist is required</div>
                <div *ngIf="f.audiologist.errors.invalidCharacterLength" class="errors_block">Minimum 10 characters needed</div>
                <!-- <div *ngIf="isSubmitted && f.audiologist.errors.pattern" class="errors_block">Enter valid Audiologist</div> -->
                <!-- <div *ngIf="isSubmitted && f.audiologist.errors.disallowedPrefix" class="errors_block">Prefix not allowed</div>
                <div *ngIf="isSubmitted && f.audiologist.errors.invalidName" class="errors_block">Name should at least have First name and Last name </div>
                <div *ngIf="isSubmitted && f.audiologist.errors.invalidCharacters" class="errors_block"> Only alphabet characters are allowed</div>  -->
              </div>
            </div>

            <div class="col-12 mb-3">
              <k-label [tooltipText]="'Tinnitus'" [helpText]="'Tinnitus'" for="dropdown" [required]="true">Tinnitus </k-label>
              <k-dropdown formControlName="tinnitus" name="dropdown" [options]="tinnitusList"></k-dropdown>
              <div *ngIf="isSubmitted && f.tinnitus.errors">
                <div *ngIf="isSubmitted && f.tinnitus.errors" class="errors_block">Tinnitus is required
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-12">
              <p>
                <label class="mr-3"><b>Apply TDH-39 Correction : </b></label>
                <k-bool-input formControlName="applytdh39Correction"></k-bool-input>
              </p>
              <div *ngIf="isSubmitted && f.applytdh39Correction.errors">
                <div *ngIf="isSubmitted && f.applytdh39Correction.errors" class="errors_block">Value is required</div>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-12">
              <p>
                <k-label [tooltipText]="'TDH-39 adjustment to 6kHz : '" [helpText]="'TDH-39 adjustment to 6kHz : '" [required]="true">TDH-39 adjustment to 6kHz : </k-label>
                <k-bool-input formControlName="allowAnchor6KHz"></k-bool-input>
              </p>
              <div *ngIf="isSubmitted && f.allowAnchor6KHz.errors">
                <div *ngIf="isSubmitted && f.allowAnchor6KHz.errors" class="errors_block">Value is required</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <k-button [type]="KButtonType.KLAiMSButton" [label]="'Save'" [color]="'brand-main'" [disabled]="saveAudiometryButton"
                (buttonClick)="saveAudiometryForm(audiometryTestForm)" class="btn_half" >
              </k-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText"
  [timeout]="timeout"></k-simple-alert>